/* template */
<template minapp="mpx" xlang="wxml"><div :class='("probability "+(pageFrom))'><div class="process-container"><div :style="[(imgUrl)] | transRpxStyle" class="image" v-if="(imgUrl)"></div><div :style="[(oneStyle)] | transRpxStyle" class="one"></div><div :style="[(bgStyle)] | transRpxStyle" class="bg"></div></div><div class="tips">- {{ tip }} -</div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m6db512d6"}'>
  .probability
    position absolute
    // top -2px
    right 12px
    // background url('https://dpubstatic.udache.com/static/dpubimg/HGc2P2TsvCgjqxO_GtpCZ.png')
    // background-repeat no-repeat
    // background-size cover
    // background pink
    z-index 10
    display flex
    flex-direction column
    align-items center
    width 154px
    height 104px
    .process-container
      width 154px
      height 85px
      display flex
      flex-direction column
      align-items center
      justify-content flex-end
      position relative
      background url('https://dpubstatic.udache.com/static/dpubimg/Dntl7EKXkr71fHNZO0S1u.png')
      background-size contain
      background-repeat no-repeat
      overflow hidden
      // border-radius 500px 500px 0 0
      .one
        position absolute
        background #FF5900
        z-index -1
        height 75px
        width 150px
        left 0px
        bottom 0
        transform-origin bottom center
        border-radius 200px 200px 0 0
        transition-duration 0.6s
      .bg
        position absolute
        z-index -2
        width 140px
        height 75px
        border-radius 200px 200px 0 0
      .image
        width 116px
        height 64px
        transition-duration 0.6s
    .tips
      line-height 12px
      font-size 12px
      color #999999
      font-weight 400
      font-family PingFangSC-Regular
      margin-top 7px
  .detail-page
    right 4px
    height 120px
    .process-container
      background-image url('https://ut-static.udache.com/webx/sfc/IqVK3Q9aadu4qqrS8OeIQ.png')
    .tips
      margin-top 10px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6db512d6"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./probability.mpx.js?isComponent&outputPath=components%2Fprobability6db512d6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./probability.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fprobability6db512d6%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6db512d6"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/probability6db512d6/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
